var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9237_17992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9237_17992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58331 20C3.15084 20 2.77883 19.8456 2.46729 19.5368C2.15576 19.2279 2 18.8546 2 18.4168C2 17.9843 2.15576 17.6123 2.46729 17.3007C2.77883 16.9892 3.15084 16.8334 3.58331 16.8334H16.4167C16.8492 16.8334 17.2212 16.9879 17.5327 17.2967C17.8442 17.6056 18 17.9789 18 18.4167C18 18.8492 17.8442 19.2212 17.5327 19.5328C17.2212 19.8443 16.8492 20 16.4167 20H3.58331ZM5.5 12.8446H6.42627L12.6555 6.60742L12.1939 6.11702L11.7372 5.68915L5.5 11.9184V12.8446ZM4.41669 13.2564V11.7421C4.41669 11.6417 4.43351 11.553 4.46717 11.476C4.50083 11.3991 4.54972 11.3286 4.61381 11.2645L12.7997 3.07861C12.9204 2.95789 13.0459 2.87349 13.1761 2.82542C13.3063 2.77734 13.4404 2.7533 13.5783 2.7533C13.7216 2.7533 13.8555 2.77734 13.98 2.82542C14.1044 2.87349 14.2251 2.95481 14.3419 3.06938L15.258 3.98086C15.3734 4.10158 15.4564 4.2255 15.5072 4.35263C15.5579 4.47977 15.5833 4.61656 15.5833 4.763C15.5833 4.89696 15.5583 5.03046 15.5083 5.1635C15.4583 5.29656 15.377 5.41934 15.2645 5.53184L7.07208 13.7228C7.00799 13.7869 6.93748 13.8371 6.86056 13.8734C6.78363 13.9098 6.69495 13.9279 6.59452 13.9279H5.08819C4.8966 13.9279 4.73679 13.8639 4.60875 13.7359C4.48071 13.6078 4.41669 13.448 4.41669 13.2564ZM12.6555 6.60742L12.1939 6.11702L11.7372 5.68915L12.6555 6.60742Z",
    fill: "#335D87"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.654496d5334ce4efc6aafa6beeb84694.svg";
export { ForwardRef as ReactComponent };